import { BridgeComponent } from "@hotwired/hotwire-native-bridge";

// Connects to data-controller="resumin--bridge--user-identification"
// このコンポーネントは、HotwireNativeで実装したアプリのみ動作します。
// Bridgeコンポーネントからアプリに対して、ユーザー識別情報を送信します。
// Firebase AnalyticsやAppsFlyerでユーザーを特定するために使用します。
//
// ログイン中:
//   <div data-controller="resumin--bridge--user-identification"
//        data-resumin--bridge--user-identification-user-id-value="12345">
//   </div>
//
// 未ログイン:
//   <div data-controller="resumin--bridge--user-identification">
//   </div>
export default class extends BridgeComponent {
  static component = "user-identification";
  static values = {
    userId: { type: String, default: "" },
  };

  connect() {
    super.connect();

    this.send("user-identification", { userId: this.userIdValue || null }, () => {});
  }
}
